module.exports = __webpack_public_path__ + "static/media/m_beard_long_round__oval_shadow.d40b3979.png";